
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';

@Component({ name: 'CompanyNature' })
export default class CompanyNature extends Vue {
  @Prop()
  private value!: undefined | number;

  // 单位性质
  private companyNature: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.companyNature = this.value;
    }

    this.options = await DictApi.getCompanyNature();
  }

  @Watch('value')
  private onValueChange(val: number) {
    this.companyNature = val;
  }

  public onValidator(): boolean {
    if (this.companyNature === null || typeof this.companyNature === 'undefined') {
      this.errorMsg = '请选择单位性质';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeCompanyNature(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="单位性质"
        errorMessage={this.errorMsg}
        >
        <SelectInput
          v-model={this.companyNature}
          title="选择单位性质"
          placeholder="选择单位性质"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeCompanyNature}
        />
      </Field>
    );
  }
}
